import { FieldType, FilterableField } from 'components/organisms/tasks/fields';

export const getCellEditorPopupPosition = ({
  type,
  fieldName,
}: FilterableField) => {
  return [
    FieldType.Date,
    FieldType.Assignee,
    FieldType.SingleUser,
    FieldType.MultiUser,
    FieldType.SingleSelect,
    FieldType.MultiSelect,
  ].includes(type) || fieldName.toLowerCase() === 'status'
    ? 'under'
    : 'over';
};
